import { render, staticRenderFns } from "./pubFooter.vue?vue&type=template&id=769e4e4d&"
import script from "./pubFooter.vue?vue&type=script&lang=js&"
export * from "./pubFooter.vue?vue&type=script&lang=js&"
import style0 from "./pubFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pubFooter.vue"
export default component.exports